import React, {useEffect, useState} from 'react';
import {Badge,Button,Tooltip} from 'antd';
import {CodeFilled, NotificationOutlined, EnvironmentOutlined, createFromIconfontCN} from '@ant-design/icons';
import {Link} from 'react-router-dom';
import config from 'src/commons/config-hoc';
import {Layout, FullScreen, HeaderSetting, isMobile} from 'ra-lib';
import { IconFont} from 'src/station';
import HeaderUser from './header-user';
import logo from './logo.png';
import cfg from 'src/config';
import './style.less';
import {locationHref, toLogin} from "../commons";

const {isDev} = cfg;

export default config({
    connect: state => ({layoutState: state.layout}),
})(function LayoutFrame(props) {
    const {action, layoutState} = props;
    const [noticeCount, setNoticeCount] = useState(0);

    async function loadData() {

        // console.log("layoutState", layoutState);
        const result = props.ajax.get('/api/company/getCompanyByUid', {userId: cfg.userId}, (e) => {
                console.log(e);
            }
        ).then(e => {
            console.log("then", e.data);
            layoutState.appName = e?.data?.name;
            layoutState.title = e?.data?.name;
        });
        const countRes = props.ajax.get('/api/notice/getNoticeCountByUserId', {userId: cfg.userId}, (e) => {
                console.log(e);
            }
        ).then(e => {
            console.log("then_countRes", e.data);
            setNoticeCount(e?.data );
        });

    }

    // 组件初始化完成之后，进行一次查询
    useEffect(() => {
        (async () => {
            await loadData();
        })();
    }, []);

    return (
        <Layout
            {...props}
            logo={logo}
            headerRight={
                <>
                    {isDev ? (<Link styleName="action" to="/gen"><CodeFilled/></Link>) : null}
                    {isMobile ? null : (
                        <>
                            <div styleName="action"><FullScreen/></div>
                            <div styleName="action" >
                                <Link styleName="action" to={"/notice/"+cfg.userId}><Tooltip placement="bottom" title={"系统通知"}>
                                    {noticeCount < 1 ? <NotificationOutlined style={{ fontSize: 14,color:"#FFFFFF" }} /> :
                                    <Badge dot> <NotificationOutlined   style={{ fontSize: 14,color:"#FFFFFF" }}/></Badge>}
                                    </Tooltip>
                                </Link>
                            </div>
                            <div styleName="action" >
                                <Link styleName="action" to={"/map"}><Tooltip placement="bottom" title={"站点位置"}>
                                    <IconFont type="icon-map" style={{ fontSize: 18, color: '#FFFFFF'}}/>
                                </Tooltip>
                                </Link>
                            </div>
                            <div styleName="action">
                                <HeaderSetting layoutState={layoutState} action={action}/>
                            </div>
                        </>
                    )}
                    <HeaderUser/>
                </>
            }
        />
    );
});
